"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _ModelXcMetaMysql = /*#__PURE__*/ _interop_require_default(require("./ModelXcMetaMysql"));
const _ModelXcMetaOracle = /*#__PURE__*/ _interop_require_default(require("./ModelXcMetaOracle"));
const _ModelXcMetaPg = /*#__PURE__*/ _interop_require_default(require("./ModelXcMetaPg"));
const _ModelXcMetaSqlite = /*#__PURE__*/ _interop_require_default(require("./ModelXcMetaSqlite"));
const _ModelXcMetaSnowflake = /*#__PURE__*/ _interop_require_default(require("./ModelXcMetaSnowflake"));
const _ModelXcMetaDatabricks = /*#__PURE__*/ _interop_require_default(require("./ModelXcMetaDatabricks"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let ModelXcMetaFactory = class ModelXcMetaFactory {
    static create(connectionConfig, args) {
        if (connectionConfig.client === 'mysql2' || connectionConfig.client === 'mysql') {
            return new _ModelXcMetaMysql.default(args);
        } else if (connectionConfig.client === 'sqlite3') {
            return new _ModelXcMetaSqlite.default(args);
        } else if (connectionConfig.client === 'pg') {
            return new _ModelXcMetaPg.default(args);
        } else if (connectionConfig.client === 'oracledb') {
            return new _ModelXcMetaOracle.default(args);
        } else if (connectionConfig.client === 'snowflake') {
            return new _ModelXcMetaSnowflake.default(args);
        } else if (connectionConfig.client === 'databricks') {
            return new _ModelXcMetaDatabricks.default(args);
        }
        throw new Error('Database not supported');
    }
};
const _default = ModelXcMetaFactory;
